import Vue from 'vue';
import Router from 'vue-router';
import CandidateDocumentPage from '@/views/CandidateDocumentPage.vue';
import OverviewPage from './views/OverviewPage.vue';
import ObservationPage from './views/ObservationPage.vue';
import InterviewPage from './views/InterviewPage.vue';
import AssessmentPage from './views/AsessmentPage.vue';
import MixedPage from './views/MixedPage.vue';
import LoginPage from './views/LoginPage.vue';
import ManualPage from './views/ManualPage.vue';
import Loader from './components/Loader';
import RunStatusBlocked from './views/RunStatusBlocked';


Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: LoginPage,
      meta: { hideNavigation: true },
    },
    {
      path: '/loader',
      name: 'loader',
      component: Loader,
      meta: { hideNavigation: true, requiresAuthentication: true },
    },
    {
      path: '/',
      name: 'home',
      redirect: 'overview'
    },
    {
      path: '/overview',
      name: 'overview',
      component: OverviewPage,
      meta: { requiresAuthentication: true },
    },
    {
      path: '/participantDocument',
      name: 'participantDocument',
      component: CandidateDocumentPage,
      meta: { requiresAuthentication: true }
    },
    {
      path: '/observation',
      name: 'observation',
      component: ObservationPage,
      meta: { requiresAuthentication: true },
    },
    {
      path: '/interview',
      name: 'interview',
      component: InterviewPage,
      meta: { requiresAuthentication: true },
    },
    {
      path: '/manual',
      name: 'manual',
      component: ManualPage,
      meta: { requiresAuthentication: true },
    },
    {
      path: '/assessment',
      name: 'assessment',
      component: AssessmentPage,
      meta: { requiresAuthentication: true },
    },
    {
      path: '/mixed',
      name: 'mixed',
      component: MixedPage,
      meta: { requiresAuthentication: true },
    },
    {
      path: '/blocker',
      name: 'blocker',
      component: RunStatusBlocked,
      meta: { requiresAuthentication: true, hideNavigation: true, isBlocker: true },
    },
  ],
});
